export default {
  searchForTheName: 'Search for the name',
  new: 'New',
  ratio: 'Ratio',
  description: 'Description',
  location: 'Location',
  angle: 'Angle',
  noDataYet: 'No data yet',
  edit: 'Edit',
  panel: 'Panel',
  initialValue: 'InitialValue',
  highReportRange: 'high report range',
  pleaseFillInTheMeasurementPointCode: 'Please fill in the measurement point code',
  highAndHigh: 'HighAndHighReporting',
  overstatementRange: 'Overstatement range',
  overstatementRangeGasOnly: 'Overstatement range used by gas alarm',
  highReportRangeGasOnly: 'high report range used by gas alarm',
  HColorLiquidOnly: 'Overreport color used by container level',
  HHColorLiquidOnly: 'high report color used by container level',
  highReporting: 'HighReporting',
  propertyExpansion: 'PropertyExpansion',
  pleaseFillInTheHighAndHighReport: 'Please fill in the high and high report',
  pleaseFillInTheScopeOfTheHighReport: 'Please fill in the scope of the high report',
  pleaseFillInTheHighReport: 'Please fill in the high report',
  pleaseFillInTheHighReportRange: 'Please fill in the high report range',
  pleaseFillInTheInitialValue: 'Please fill in the initial value',
  rotation: 'Rotation',
  saveFailed: 'Save failed',
  theModificationWasSuccessful: 'The modification was successful',
  modificationFailed: 'Modification failed',
  whethertoDeleteTheSelectedPanel: 'Whether to delete the selected panel',
  deviceNumber: 'DeviceNumber',
  deviceName: 'DeviceName',
  creatorName: 'CreatorName',
  objectEncoding: 'Object encoding',
  creationTime: 'CreationTime',
  delete: 'Delete',
  deviceCategory: 'DeviceCategory',
  saveSuccessfully: 'Save successfully',
  dynamicModels: 'Dynamic models',
  pleaseEnter: 'Please enter',
  color: 'Color',
  associativeMeasurementPoints: 'Associative measurement points',
  parentNode: 'Parent node',
  confirm: 'Confirm',
  HColor: 'Overreport color',
  HHColor: 'high report color',
  measurementPoint: 'Measurement point',
  cancel: 'Cancel',
  whetherToConfirmTheDeletionOfTheCurrentDynamicDeviceEffect:
    'Whether to confirm the deletion of the current dynamic device effect?',
  deviceCategoryAcquisitionFailed: 'Device category acquisition failed',
  deviceEncodingOrDeviceName: 'Device encoding or device name',
  measuringPointInfo: 'measuring point code or measuring point name',
  export: 'Export',
  import: 'Import',
  serialNumber: 'Ordinal',
  operate: 'Operate',
  check: 'Check',
  save: 'Save',
  measurementPointCoding: 'Measurement point coding',
  unit: 'Unit',
  measurementPointName: 'Measurement point name',
  return: 'Return',
  reset: 'Reset',
  tips: 'Tips',
  theDeletionWasSuccessful: 'The deletion was successful',
  addedSuccess: 'Added success',
  addedFailures: 'Added failures',
  editSuccessfully: 'Edit successfully',
  editFailed: 'Edit failed',
  search: 'Search',
}
